// src/assets/data/ModelSpecificationTemplates/modelTemplates.js

// ── Model Specification templates ──────────────────────────────────────────────
export const modelTemplateNames = [
  "Logistic Regression",
  "Time-Series",
  "Gradient-Boosted Trees",
  "Neural Network",
  "Rule-Based / Scorecard",
  "Ensemble / Hybrid",
  "Expert Judgment / Overlay",
  "Generative AI",
];

const FILE_MAP = {
  "Logistic Regression": "logistic_regression.md",
  "Time-Series": "time_series.md",
  "Gradient-Boosted Trees": "gradient_boosted_trees.md",
  "Neural Network": "neural_network.md",
  "Rule-Based / Scorecard": "rule_based_scorecard.md",
  "Ensemble / Hybrid": "ensemble_hybrid.md",
  "Expert Judgment / Overlay": "expert_judgment_overlay.md",
  "Generative AI": "generative_ai.md",
};

export async function fetchTemplateMd(templateName) {
  const file = FILE_MAP[templateName];
  if (!file) {
    throw new Error(`Unknown model template: ${templateName}`);
  }
  const base = "/data/ModelSpecificationTemplates";
  const url = `${base}/${file}`;
  const res = await fetch(url, { cache: "no-cache" });
  if (!res.ok) throw new Error(`Failed to load ${file} (${res.status})`);
  return res.text();
}


